<template>
  <div class="container">
    <div class="search-container">
      <search-input
        class="search-input"
        type="text"
        v-model="SearchDid"
        placeholder="Search for DID"
      />
      <div class="buttons-wrapper">
        <secondary-button
          @click.native="$router.push({name: 'reseller-dids-import-did'})"
          class="secondary-button importDid"
        >Import DID</secondary-button>
        <secondary-button
          @click.native="$router.push({name: 'reseller-dids-add-did'})"
          class="secondary-button addDid"
        >Add DID</secondary-button>
        <secondary-button @click.native="deleteAll()" class="secondary-button deleteAll">Delete All</secondary-button>
        <secondary-button
          @click.native="deleteSelected()"
          class="secondary-button deleteSelected"
        >Delete Selected</secondary-button>
      </div>
    </div>
    <table class="Invoice_table">
      <thead>
        <tr class="Invoice_table_header">
          <th>
            <img
              v-if="isAllActive"
              class="number-icon"
              @click="allActive()"
              src="@/assets/Icon/Check/Active.svg"
              alt
            />
            <img
              v-if="!isAllActive"
              class="number-icon"
              @click="allActive()"
              src="@/assets/Icon/Check/Default.svg"
              alt
            />Number
          </th>
          <th>Created On</th>
          <th>Created By</th>
          <th>Country</th>
          <th>Type</th>
          <th>DID type</th>
          <th>Assigned To</th>
          <th></th>
          <th class="icon"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="line" v-if="dids.length > 0" v-for="(did, k) in dids" :key="k">
          <th>
            <img
              v-if="did.active"
              class="number-icon"
              @click="isActive(did)"
              src="@/assets/Icon/Check/Active.svg"
              alt
            />
            <img
              v-if="!did.active"
              class="number-icon"
              @click="isActive(did)"
              src="@/assets/Icon/Check/Default.svg"
              alt
            />
            {{did.number}}
          </th>
          <th>{{did.createdOn}}</th>
          <th>{{did.createdBy}}</th>
          <th>{{did.countryName}}</th>
          <th>{{did.type}}</th>
          <th>{{did.didType}}</th>
          <th>{{did.assignedTo}}</th>
          <th>
            <primary-button class="callflow">New Callflow</primary-button>
          </th>
          <th class="icon">
            <svg
              @click="$router.push({name: 'reseller-dids-edit-did', params: {id: did.number}})"
              class="svg-grey edit"
              width="30px"
              height="30px"
              viewBox="0 0 30 30"
              version="1.1"
            >
              <path
                d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                id="path-1"
              />
            </svg>
            <svg
              @click="deleteDid(did.number)"
              class="svg-grey"
              width="30px"
              height="30px"
              viewBox="0 0 30 30"
              version="1.1"
            >
              <path
                d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                id="path-1"
              />
            </svg>
          </th>
        </tr>
      </tbody>
    </table>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :per-page="PerPage"
        :total="TotalPages"
        :qnt="dids.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue")
  },
  data: () => ({
    showDropDown: false,
    dids: [],
    Page: 0,
    SearchDid: "",
    PerPage: null,
    Total: null,
    TotalPages: null,
    active: null,
    isAllActive: false,
    selectedDids: []
  }),
  watch: {
    SearchDid: function() {
      this.Page = 0;
      this.GetList();
    }
  },
  created() {
    this.GetList();
  },
  methods: {
    isActive(did) {
      this.selectedDids.push(did.number);
      this.active = !this.active;
      this.dids.map(item => {
        if (item == did) {
          did.active = !did.active;
        }
      });
    },
    changePage(page) {
      this.Page = page;
      this.GetList(this.Searched, this.Page);
    },
    allActive() {
      this.isAllActive = !this.isAllActive;
      this.dids.map(item => {
        this.selectedDids.push(item);
        item.active = this.isAllActive;
      });
    },
    GetList() {
      this.$store
        .dispatch("GetDids", {
          did: this.SearchDid.trim(),
          page: this.Page,
          resellerId: this.$store.state.user.user.reseller_uuid
        })
        .then(res => {
          console.log("res from did/list--->", res);
          this.dids = res.items.map(this.transformDids);
          this.PerPage = res.per_page;
          this.Total = res.total;
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformDids(i, k) {
      return {
        number: i.did,
        createdBy: i.created_by,
        countryName: i.iso3,
        createdOn: format(i.created_on, "D MMM YYYY"),
        assignedTo: i.company_name,
        type: i.type,
        didType: i.did_type,
        active: false
      };
    },
    deleteDid(did) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this did!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("DeleteDid", did)
            .then(() => {
              this.$swal("Edited!", "Did has been deleted.", "success");
              this.GetList();
            })
            .catch(err => {
              this.$snotify.error(err.response.data.errors[0]);
            });
        }
      });
    },
    deleteAll() {
      if (this.dids.length === 0) {
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover all DIDs!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("DeleteAllDids").then(res => {
            this.GetList();
            this.$swal(
              "Deleted!",
              "Your all DIDs has been deleted.",
              "success"
            );
          });
        }
      });
    },
    deleteSelected() {
      if (this.selectedDids.length === 0) {
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this DIDs!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("DeleteSelectedDids", this.selectedDids)
            .then(res => {
              this.GetList();
              this.$swal(
                "Deleted!",
                "Selected DIDs has been deleted.",
                "success"
              );
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
    margin-top: 20px;
    .secondary-button {
      height: 40px;
      width: 90px;
      margin-right: 15px;
      margin-bottom: 0;
    }
  }
}
.search-container {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  .search-input {
    height: 36px;
    width: 345px;
    background-color: #ffffff;
  }
  .secondary-button {
    border-radius: 4px;
    background-color: #51a3f3;
    color: #ffffff;
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
    margin-top: 0;
    .secondary-button {
      border-radius: 4px;
      background-color: #51a3f3;
      color: #ffffff;
    }
    .secondary-button.importDid {
      height: 40px;
      width: 140px;
      margin-right: 15px;
    }
    .secondary-button.addDid {
      height: 40px;
      width: 120px;
      margin-right: 15px;
    }
    .secondary-button.deleteAll {
      height: 40px;
      width: 140px;
      margin-right: 20px;
    }
    .secondary-button.deleteSelected {
      height: 40px;
      width: 160px;
      margin-right: 20px;
    }
  }
}
table.Invoice_table {
  width: 99%;
}
table thead tr {
  background: #f8f9fe;
  height: 37px;
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 0px 10px 0 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  padding: 11px 20px 10px 0;
}
.Invoice_table_header th:first-child {
  padding-left: 20px;
  padding-right: 100px;
}
tbody th:first-child {
  padding-left: 20px;
  padding-right: 30px;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
  padding-right: 5px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 10px;
}
tr th.icon {
  width: 80x;
  float: right;
}
tbody {
  th.icon {
    padding: 7px 20px 7px 0;
    .edit {
      margin-right: 20px;
    }
  }
  .img-container {
    padding: 7px 0;
  }
}
.Invoice_price {
  font-family: "Helvetica Neue";
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 20px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 35px;
}
th .svg-grey {
  cursor: pointer;
  fill: #55616e;
}
th .callflow {
  font-size: 12px;
  width: 86px;
  height: 20px;
  padding-top: 0px;
  float: right;
  line-height: 20px;
}
th .number-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
</style>

